import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as MultiSearchActions from "../actions";
import type { IMultiSearchQueryState } from "../types";

const initialState: IMultiSearchQueryState = {
  textValue: "",
  tokenizedValue: []
};

export default function multiSearchReducer(
  state: IMultiSearchQueryState = initialState,
  action: ActionType<typeof MultiSearchActions>
): IMultiSearchQueryState {
  switch (action.type) {
    case getType(MultiSearchActions.setTokenizedQuery):
      return { ...state, tokenizedValue: action.payload };

    case getType(MultiSearchActions.setSearchText):
      return { ...state, textValue: action.payload };

    case getType(MultiSearchActions.resetSearch):
      return { ...initialState };
    default:
      return state;
  }
}
